<template lang="pug">
  .component-credit-bonus-configuration
    ModalReveal(@modalOpen="load", ref="bonusModal")
      button.button(slot="trigger", v-if="item.amount !== null" ) Info

      .row.text-center(v-if="info !== null" )
        template(v-if="checkConfig.length" )
          .column
            h2 Used Amount
            h3 {{$priceWithcurrency(info.used_amount)}}
          .column
            h2 Amount Left
            h3 {{$priceWithcurrency(info.amount_left)}}
        .column
          h2 Use count
          h3 {{info.use_count}}
</template>

<script>
import SelectizeClientType from '../../structure/ui/lists/selectize/SelectizeClientType'
import DeleteConf from './DeleteConf'
import ModalReveal from "../../structure/foundation/ModalReveal.vue";
import Editor from "../../structure/ui/Editor.vue";
import ArrayEdit from "../../structure/ui/ArrayEdit.vue";
import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";

export default {
  name: 'CreditBonusInformation',
  components: {ArrayEdit, Editor, ModalReveal, DeleteConf, SelectizeClientType},
  data() {
    return {
      info: null,
      slot: "footer",

    }
  },
  mounted() {

  },
  created() {
  },
  methods: {
    load() {
      if (this.item.amount == null) {
        return
      }
      const slugify = str =>
        str
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, '')
          .replace(/[\s_-]+/g, '_')
          .replace(/^-+|-+$/g, '');
      KeplerBackofficeSdk.promotionalOffering.select(slugify(this.item.name)).get((data) => {
        this.info = data
      })


      this.$emit('update')
    }
  },
  computed: {
    checkConfig() {
      if (this.item.config == null){
        return {}
      }
      return this.item.config.split('|').filter((item)=> item === 'action:book')
    }
  },
  props: ['item']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreditBonusInformation.vue?068d5a5c